import { MulticastDelegate } from "flavr-common";
const MAX_EVENT_LOG_SIZE = 500;
class TrainingDebugService {
    constructor() {
        this.onChangedDelegate = new MulticastDelegate();
        this.onEventLogChangedDelegate = new MulticastDelegate();
        this.snapshot = {
            version: 0,
            hasToml: false,
            scenario: undefined,
            currentStageId: undefined
        };
        this._nextKey = 0;
        this._eventLog = [];
    }
    getSnapshot() {
        return this.snapshot;
    }
    setTomlDetected(hasToml) {
        if (this.snapshot.hasToml === hasToml)
            return;
        this.snapshot = Object.assign(Object.assign({}, this.snapshot), { version: this.snapshot.version + 1, hasToml });
        this.onChangedDelegate.invoke();
    }
    setScenario(scenario) {
        var _a;
        const currentStageId = (_a = scenario === null || scenario === void 0 ? void 0 : scenario.getCurrentState()) === null || _a === void 0 ? void 0 : _a.id;
        if (this.snapshot.scenario === scenario && this.snapshot.currentStageId === currentStageId)
            return;
        this.snapshot = Object.assign(Object.assign({}, this.snapshot), { version: this.snapshot.version + 1, scenario,
            currentStageId });
        this.onChangedDelegate.invoke();
    }
    setCurrentStageId(currentStageId) {
        if (this.snapshot.currentStageId === currentStageId)
            return;
        this.snapshot = Object.assign(Object.assign({}, this.snapshot), { version: this.snapshot.version + 1, currentStageId });
        this.onChangedDelegate.invoke();
    }
    notifyChanged() {
        this.snapshot = Object.assign(Object.assign({}, this.snapshot), { version: this.snapshot.version + 1 });
        this.onChangedDelegate.invoke();
    }
    getEventLog() {
        return this._eventLog;
    }
    logEvent(type, id, detail) {
        this._eventLog.unshift({ key: this._nextKey++, timestamp: Date.now(), type, id, detail });
        if (this._eventLog.length > MAX_EVENT_LOG_SIZE)
            this._eventLog.length = MAX_EVENT_LOG_SIZE;
        this.onEventLogChangedDelegate.invoke();
    }
    clearEventLog() {
        this._eventLog = [];
        this.onEventLogChangedDelegate.invoke();
    }
    clear() {
        this.snapshot = {
            version: this.snapshot.version + 1,
            hasToml: false,
            scenario: undefined,
            currentStageId: undefined
        };
        this._eventLog = [];
        this.onChangedDelegate.invoke();
        this.onEventLogChangedDelegate.invoke();
    }
}
export const trainingDebugService = new TrainingDebugService();
